import {Fragment } from "react"
import {SkipDays} from "../../calendarBuilder"


export const January = () => {
    return (
        <Fragment>{SkipDays(4, 6, [])}</Fragment>  
    )
}
